module.exports = __webpack_public_path__ + "img/icon-calc.d855f8d2.svg";